// dependencies imports ⇒
import React from "react";
// assets and scss imports ⇒
import forwordArrow from "../../../../../assets/arrow-down.png";
import "./consentListTableCell.scss";

// project file imports(UI components) ⇒
// const file imports(helper methods, etc) ⇒

function ConsentListTableCell(props) {
  // const declarations ⇒
  const { consentList, setConsentRequestId, handleSelectPage } = props;

  // let or var declarations ⇒
  // life cycle methods ⇒
  // API Calls ⇒
  // Helper methods ⇒
  // Actions ⇒

  const handleViewConsentGranted = (data) => {
    setConsentRequestId(data.consent_request_id);
    handleSelectPage(4);
  };

  // create UI ⇒

  const consentListTableCellUI = () => {
    return (
      <>
        {consentList.map((data, ind) => (
          <div
            key={ind}
            className={`consent-table-cell-wrapper ${
              data?.status === "Consent Granted" && "active-table-cell"
            }`}
            onClick={
              data?.status === "Consent Granted" &&
              (() => handleViewConsentGranted(data))
            }
          >
            <div className="consent-table-cell-list">
              <div className="consent-table-cell-list-title">
                {data?.status}
              </div>
            </div>
            <div className="consent-table-cell-list">
              <div className="consent-table-cell-list-title">
                {data?.created_at}
              </div>
            </div>
            <div className="consent-table-cell-list-last">
              <div className="consent-table-cell-list-title">
                {data?.granted_at}
              </div>
              {data?.status === "Consent Granted" && (
                <img
                  className="consent-table-cell-btn-arrow"
                  src={forwordArrow}
                />
              )}
            </div>
          </div>
        ))}
      </>
    );
  };

  //

  return <div>{consentListTableCellUI()}</div>;
}

export default ConsentListTableCell;
